import React from 'react';
import config from '../../config';

import logoSmallA from '../assets/images/logo-small-a.png';

export default function SocialLinks() {
	return (
		<section className="contact-section bg-color-primary-blue">
			<div className="container">
				<div className="row d-flex justify-content-center m-0 pt-4">
					<a className="navbar-brand" href="/">
						<img className="img-fluid" src={logoSmallA} alt="" />
					</a>
				</div>
				<div className="row">
          <div className="col-lg-3"></div>
					<div className="social d-flex justify-content-center pb-4 col-lg-6">
						{config.socialLinks.map(social => {
							const { icon, url } = social;
							return (
								<a key={url} href={url} className={`mx-2`}>
									<i className={`fab ${icon}`}></i>
								</a>
							);
						})}
					</div>
          <div className="col-lg-3">
            {/* <h2 className="text-white-50">Get in touch</h2>
            <a href="contact">Contact</a> */}
          </div>
				</div>
			</div>
		</section>
	);
}
